import { H2 } from '@components/Typography';
import styled from 'styled-components';

export const RecommendedForYouCarouselRoot = styled.div<{ padding?: string }>`
  font-family: proxima-nova, sans-serif;

  background-color: #f3fcfe;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 4rem 0;
  margin-bottom: 6rem;

  .react-multi-carousel-list {
  }

  .react-multiple-carousel__arrow {
    background-color: ${({ theme }) => theme.color.mobilityGrey};
    border-radius: 1rem;
  }

  .react-multiple-carousel__arrow--left {
    left: 0rem;
  }

  .react-multiple-carousel__arrow--right {
    right: 0rem;
    z-index: 1;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 2rem 2rem;
    margin-top: 2rem;
  }
`;

export const Title = styled(H2)<{ color?: string }>`
  color: ${({ color, theme }) => color || theme.color.white};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size32};
  line-height: ${({ theme }) => theme.lineHeight.height130};
  text-align: left;

  width: 100%;
  max-width: 143rem;
  margin: 0 auto 2rem auto;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size28};
    margin-bottom: 0rem;
    text-align: center;
  }
`;

export const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 143rem;
  padding: 2rem 0rem;
`;

export const RightSideWrapper = styled.div`
  padding: 5rem 6rem 5rem 0;
  margin-left: 14rem;
  width: min(100%, 46rem);

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    margin: auto;
    width: min(100%, 50rem);
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding-left: 5rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    margin: auto;
    padding: 5rem 2rem;
  }
`;

export const UnderlineContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0 auto;
  width: 100%;
  max-width: 143rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    justify-content: flex-start;
  }
`;

export const Underline = styled.div<{
  color?: string;
}>`
  width: 16rem;
  height: 0.4rem;
  background-color: ${({ color, theme }) => color || theme.color.white};
`;

export const ItemWrapper = styled.div`
  margin-right: 1.5rem;
`;

export const CustomItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const MediaCard = styled.div<{
  height: string;
  width: string;
}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

  /* optional micro-lift */
  transition: transform 0.25s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  transition: transform 0.5s ease;
  transform-origin: center;

  ${MediaCard}:hover & {
    transform: scale(1.25);
  }
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;

  transition: transform 0.5s ease;
  transform-origin: center;

  ${MediaCard}:hover & {
    transform: scale(1.25);
  }
`;

export const TextRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
`;

export const ItemTitle = styled.div`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size14};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  line-height: ${({ theme }) => theme.lineHeight.height130};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size12};
    font-weight: ${({ theme }) => theme.fontWeight.weight900};
  }
`;

export const ItemSubtitle = styled.div`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size14};
  font-weight: ${({ theme }) => theme.fontWeight.weight700};
  line-height: ${({ theme }) => theme.lineHeight.height140};
  overflow: hidden;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size12};
    font-weight: ${({ theme }) => theme.fontWeight.weight900};
  }
`;

export const ProgressBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const ProgressBarContainer = styled.div`
  background-color: ${({ theme }) => theme.color.greyMedium};
  position: relative;
  margin-top: 2rem;
  width: 40%;
  height: 3px;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    width: 19.1rem;
  }
`;

export const ProgressFill = styled.div<{ width: number; color: string }>`
  width: ${({ width }) => width}%;
  height: 100%;
  background-color: ${({ color }) => color};
  transition: width 0.3s ease-in-out;
`;
